import React from 'react';
import { modelClass } from '/imports/api/escrows';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const EscrowsPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: 'botId', label: 'Bot ID' }, { field: 'bot', label: 'Bot' }, { field: 'partnerId', label: 'Partner ID' }, { field: 'partner', label: 'Partner' }, { field: 'tradeno', label: 'Trade No' }, { field: 'completed', label: 'Completed' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
